import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  ActivationEnd,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Role } from '@interfaces/user';
import { AuthService } from '@services/auth.service';
import { NavigationService } from '@services/navigation.service';
import { UserService } from '@services/user.service';
import { filter, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * AuthGuard class that implements the CanActivate interface to protect routes from unauthorized access.
 */
export class AuthGuard {
  constructor(
    public authService: AuthService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private navigationService: NavigationService,
    private userService: UserService,
  ) {}

  /**
   * Method that determines if the user can activate the route.
   * @param next - The ActivatedRouteSnapshot instance.
   * @param state - The RouterStateSnapshot instance.
   * @returns A boolean, UrlTree, Promise<boolean | UrlTree>, or Observable<boolean | UrlTree> indicating if the user can activate the route.
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree | undefined {
    // Redirect non admin trying to access admin route.
    this.router.events
      .pipe(filter((routerEvent: any) => routerEvent instanceof ActivationEnd))
      .subscribe((routerEvent: ActivationEnd | any) => {
        const routeData = routerEvent.snapshot.data;
        if (routeData.roles && !routeData.roles.includes(this.userService.getUserData()?.role as Role)) {
          this.navigationService.navigateForbidden();
          return of(false);
        }
        return of(true);
      });
    return true;
  }
}
